import { useAppSelector } from '@app/redux/hooks';
import { ImpersonationInfo } from '@app/services/admin';

export const ImpersonationBanner = () => {
  const user = useAppSelector((state) => state.auth.user);

  const getImpersonation = (): ImpersonationInfo | null => {
    try {
      const data = localStorage.getItem('impersonation');
      return data ? JSON.parse(data) : null;
    } catch {
      return null;
    }
  };

  const impersonation = getImpersonation();

  if (!impersonation?.isImpersonating) return null;

  const handleExit = () => {
    const adminToken = localStorage.getItem('adminToken');
    if (adminToken) {
      localStorage.setItem('accessToken', adminToken);
    }

    localStorage.removeItem('impersonation');
    localStorage.removeItem('adminToken');
    localStorage.removeItem('businessId');
    localStorage.removeItem('userPlanTypes');

    window.location.href = '/admin/users';
  };

  return (
    <div className="sticky top-0 left-0 right-0 bg-amber-500 text-white px-4 py-2 flex justify-between items-center z-[9999]">
      <span className="text-sm font-medium">
        You are viewing as {user?.email || 'user'}
      </span>
      <button
        onClick={handleExit}
        className="bg-white text-amber-600 px-3 py-1 rounded text-sm font-medium hover:bg-amber-50 transition-colors"
      >
        Exit Impersonation
      </button>
    </div>
  );
};
